import React from 'react'
import NewsFeedItemContainer from './StyledNewsFeedItemContainer'
import NewsFeedLink from './StyledNewsFeedLink'
import NewsFeedImage from './StyledNewsFeedImage'
import NewsFeedTitle from './StyledNewsFeedTitle'
import NewsFeedAdvertSign from './StyledNewsFeedAdvertSign'

const NewsFeedItemIdvert = () => {
  return (
    <NewsFeedItemContainer className='idvert-wrapper' style={{ display: 'none' }}>
      <NewsFeedLink className='idvert-perex-link'>
        <NewsFeedImage className='idvert-perex-img' alt='idvert'/>
        <NewsFeedTitle className='idvert-perex-title'/>
        <NewsFeedAdvertSign>komerční článek</NewsFeedAdvertSign>
      </NewsFeedLink>
    </NewsFeedItemContainer>
  )
}

export default NewsFeedItemIdvert
